import { render, staticRenderFns } from "./DriversTable.vue?vue&type=template&id=188de5e6&"
import script from "./DriversTable.vue?vue&type=script&lang=js&"
export * from "./DriversTable.vue?vue&type=script&lang=js&"
import style0 from "./DriversTable.vue?vue&type=style&index=0&id=188de5e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports